module.exports = __webpack_public_path__ + "static/img/bg.a80fbf95.jpg";